import LayoutBasic from "@/views/layouts/LayoutBasic";
import Download from "@/views/fileStorage/Download.vue";
import PostStickers from "@/views/fileStorage/PostStickers.vue";

const routes = {
  path: '/files',
  component: LayoutBasic, // Change the desired Layout here
  meta: {requiresAuth: true},
  children: [
    {
      path: 'download',
      name: 'FilesDownload',
      component: Download
    },
    {
      path: 'post/stickers',
      name: 'PostStickers',
      component: PostStickers
    },
  ]
};

export default routes;
